import { InteractService } from './../services/interact.service';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { Signatory } from '../model/signatory';
import { NewEnvelopeService } from '../new-envelope/new-envelope.service';
import { SignatureImageUtils } from 'src/app/modules/signature/components/signature-modal-electronic/signature-image.utils';
import { SignatureCanvasUtils } from 'src/app/modules/signature/components/signature-modal-electronic/signature-canvas-utils';
import { TranslateService } from '@ngx-translate/core';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { StringUtil } from 'src/app/util/string-util';
import { SubscriberTypeEnum } from 'src/app/enum/subscribe-type-enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OnboardingService, IOnboarding, LayoutService, IToast, ToastService, IOnboardingTour } from 'codex-lib';
import { EnvelopeOnBoardingService } from '../services/envelope-on-boarding.service';
import { SignatoryStamp } from '../model/signatory-stamp';
import { Observable, Subject, Subscription } from 'rxjs';
import { BrowserUtil } from 'src/app/util/browser-util';
import * as R from 'ramda';
import { PDFSource } from 'ng2-pdf-viewer';
import { PageUtil } from 'src/app/util/page-util';
import { CoordenatesPage } from '../model/coordenates-page';
import { FileValidateService } from '../services/file-validate.service';
import { LanguageBase } from '../model/language';
import { take } from 'rxjs/operators';
import { RubricStamp } from '../model/rubric-stamp';
import { FileConfig } from '../model/file-config';
import { RubricImageUtils } from 'src/app/modules/signature/components/signature-modal-electronic/rubric-image.utils';
import { FeatureEnum } from 'src/app/enum/feature.enum';
import { RubricPosition } from '../model/rubric-position';
import { FileUtil } from 'src/app/util/file-utils';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { ComponentDragDropService } from '../services/component-drag-drop.service';
import { onBoardingSignaturePositionTourBase, onBoardingFormFieldsStep, onBoardingSignaturePositionTourOptions } from '../onboarding/onboarding-signature-position-tour';
import { FormCustomField } from '../model/form-custom-field';
import { CustomFieldTypeEnum } from 'src/app/enum/custom-field-type.enum';

const type = 'application/pdf';
@Component({
  selector: 'app-envelope-signatures',
  templateUrl: './envelope-signatures.component.html',
  styleUrls: ['./envelope-signatures.component.scss'],
})
export class EnvelopeSignaturesComponent implements OnInit, OnDestroy {
  @ViewChild('modalOnBoarding') modalOnBoardingRef: TemplateRef<any>;
  showOnboarding;
  showOnboardingNewWorking;
  showOnboardingRememberLater;


  languageSelected: any;
  languageBase: LanguageBase;

  onBoardingSignPosition: IOnboardingTour;
  onBoardingIsIsolatedFormTour: boolean = false;

  files: File[];
  pdfSrc: string | PDFSource | ArrayBuffer;
  signatories: Array<Signatory>;
  isOrdered: boolean;
  backgroundImage = SignatureImageUtils.backgroundImage;
  backgroundImageRubric = RubricImageUtils.backgroundImage;
  titleStamp = this.translate.instant('signatureModal.headerText');
  titleRubricStamp = this.translate.instant('signatureModal.rubric');
  today = '';
  listItems: Array<any> = [];
  listFiles: File[] = [];
  activeModal: NgbActiveModal;
  isMobile: boolean = BrowserUtil.isMobile();
  hasChangeElements = false;
  hasChangeFiles = false;
  initial = false;
  hasChangeElementsRubric = false;
  hasChangeFilesRubric = false;
  rubricPosition: RubricPosition[] = [];
  pageSelected: string;
  showOnboardingMobile: boolean;
  showOnBoardingPosition = false;

  withRubrics = this.interactService.withRubrics;

  private fileSubscription: Subscription;
  private listFilesSubscription: Subscription;
  private pageSelectedSbscription: Subscription;
  private listFiles$ = new Subject<any>();
  private blockZoom = (e: WheelEvent & KeyboardEvent & TouchEvent) => {
    const isZoomShortcut =
      e.ctrlKey &&
      'key' in e &&
      ['+', '-', '=', '_', '0'].includes(e.key);

    const isPinchZoom =
      'touches' in e &&
      e.touches?.length > 1;

    if (isZoomShortcut || isPinchZoom) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  constructor(
    private componentDragDropService: ComponentDragDropService,
    private newEnvelopeService: NewEnvelopeService,
    private signatureCanvasUtils: SignatureCanvasUtils,
    private translate: TranslateService,
    private interactService: InteractService,
    private onboardingService: OnboardingService,
    private envelopeOnBoardingService: EnvelopeOnBoardingService,
    private layoutService: LayoutService,
    public fileValidateService: FileValidateService,
    private toastService: ToastService) {

    pdfDefaultOptions.defaultCacheSize = 1000;
    this.languageBase = new LanguageBase(translate);
    this.languageBase.init().pipe(take(1)).subscribe(console.log);
  }

  ngOnDestroy() {
    this.interactService.stopInteract('signature');
    this.interactService.stopInteract('rubric');
    this.interactService.stopInteract(CustomFieldTypeEnum.TextField);
    this.interactService.stopInteract(CustomFieldTypeEnum.CheckboxField);
    this.fileSubscription.unsubscribe();
    this.pageSelectedSbscription.unsubscribe();
    this.listFilesSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    document.addEventListener('wheel',      this.blockZoom, { passive: false });
    document.addEventListener('keydown',    this.blockZoom);
    document.addEventListener('touchstart', this.blockZoom, { passive: false });

    if (!this.isMobile) {
      if (this.newEnvelopeService.needCreateFirstEnvelope)
        this.buildOnBoardingTour(false);
      else if (this.newEnvelopeService.includeComponent)
        this.envelopeOnBoardingService.verifyViewed(FeatureEnum.positionForm).subscribe(viewed => {
          if (!viewed)
            this.buildOnBoardingTour(true);
        });
    }
  }

  buildOnBoardingTour(isolatedFormFields: boolean) {
    this.onBoardingIsIsolatedFormTour = isolatedFormFields;
    const tourOptions = { ...onBoardingSignaturePositionTourOptions };
    if (isolatedFormFields) {
      tourOptions['steps'] = [onBoardingFormFieldsStep];
    } else {
      const steps = [...onBoardingSignaturePositionTourBase.steps];
      if (this.newEnvelopeService.includeComponent) {
        steps.push(onBoardingFormFieldsStep);
      }
      tourOptions['steps'] = steps;
    }
    this.onBoardingSignPosition = tourOptions as IOnboardingTour;

    this.showOnBoardingPosition = true;
    this.onboardingService.openOnboarding(true, 'onboardingSignPosition');
    this.onboardingService.registerOnboarding('onboardingSignPosition');
  }

  ngOnInit() {
    if (!this.isMobile) this.newEnvelopeService.verifySignatoriesLimit();
    this.observerFileSelected();
    this.observerPageSelected();
    this.observerListFiles();
    this.getData();

    let signatorys = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)["elements"] as Array<Signatory>;
    if (signatorys.find(x => x.signatureType.id === 0 || x.signatureType.id === 1)) {
      if (this.isMobile) {
        const toast: IToast = { text: this.translate.instant('businessError.rubricWarningMobile'), autoHide: true, type: 'warning' };
        this.toastService.createNewToast(toast);
      }
    }

    this.onboardingService.registerOnboarding('onboardingSignPosition');
  }

  observerListFiles() {
    this.listFilesSubscription = this.getSubjectListFiles()
      .subscribe((res) => {
        this.layoutService.toggleLoading(true);
        this.loadInitialFile(res[0]);
        this.newEnvelopeService.envelopeFiles.map(x => x.checked = false);
        this.newEnvelopeService.envelopeFiles[0].checked = true;
        this.selectedPage();
      });
  }

  observerFileSelected() {
    this.fileSubscription = this.newEnvelopeService
      .getSubjectfileSelected()
      .subscribe((res) => {
        this.layoutService.toggleLoading(true);
        this.loadFile(res);
      });
  }

  observerPageSelected() {
    this.pageSelectedSbscription = this.newEnvelopeService
      .getSubjectPageSelected()
      .subscribe((page) => {
        this.pageSelected = page;
      });
  }

  onPageChangeByViewer(value) {
    const fileName = FileUtil.removeExt(this.newEnvelopeService.envelopeFiles.find(x => x.checked === true).name);
    this.fileValidateService.fileConfig.filter(x => x.fileName === fileName).map(x => x.selected = false);
    this.fileValidateService.fileConfig.find(x => x.fileName === fileName && x.page === value.toString()).selected = true;
    this.newEnvelopeService.setSubjectPageSelected(value.toString());
  }

  getSubjectListFiles(): Observable<any> {
    return this.listFiles$.asObservable();
  }

  setSubjectListFiles(data: any) {
    this.listFiles$.next(data);
  }

  getData() {
    this.fileValidateService.fileConfig.forEach((x) => {
      x.lockRubric = false;
    });
    this.files = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Upload);
    this.signatories = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)['elements'];
    this.isOrdered = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)['isOrdered'];
    this.hasChangeFiles = this.verifyChangeFile();
    this.hasChangeElements = this.verifyChangeSignatories(this.signatories, this.isOrdered);
    this.hasChangeElementsRubric = this.hasChangeElements;
    this.interactService.isOrdered = this.isOrdered;

    if (this.hasChangeFiles || this.hasChangeElements) {
      this.clearSignatureConfig();
      this.clearIncludeRubricsFileConfig();
      this.clearCustomFieldsConfig();
    }

    this.listFiles = this.files;
    this.setSubjectListFiles(this.listFiles);

  }

  removeExt(fileName: string) {
    return FileUtil.removeExt(fileName);
  }

  loadInitialFile(file: File) {
    const blob = new Blob([file], { type });
    this.pdfSrc = URL.createObjectURL(blob);
    this.interactService.fileName = FileUtil.removeExt(file.name);
    if (this.withRubrics) {
      this.validRubricsHeight();
    }
  }

  initCanvas(el, textCanvas) {
    this.signatureCanvasUtils.addTextTitleSignatory(textCanvas, this.titleStamp, 2);
    this.signatureCanvasUtils.addTextDateSignatory(textCanvas, this.today);
    this.signatureCanvasUtils.addTextSignatory(textCanvas, el.name);
    this.signatureCanvasUtils.addTextFullNameSignatory(textCanvas, el.name);
    this.signatureCanvasUtils.addTextPersonalSignatory(textCanvas, CPFCNPJUtil.isCPF(el.ssn), !StringUtil.isNullOrEmpty(el.ssn), el.ssn);
  }

  initRubricCanvas(el, textCanvas) {
    const name = el.name.trim().split(' ');
    const first = [...name].shift();
    const last = [...name].pop();
    this.signatureCanvasUtils.addTextTitleRubric(textCanvas, this.titleRubricStamp);
    this.signatureCanvasUtils.addTextRubric(textCanvas, first[0].toUpperCase() + last[0].toUpperCase());
  }

  loadFile(file: File) {
    const blob = new Blob([file], { type });
    this.pdfSrc = URL.createObjectURL(blob);
    this.interactService.fileName = FileUtil.removeExt(file.name);
    this.hasChangeElements = false;
    this.hasChangeFiles = false;
    this.fileValidateService.fileConfig.map(x => x.selected = false);
    let maxPage = 0;
    let files = this.fileValidateService.fileConfig.filter(x => x.fileName === this.interactService.fileName);
    files.forEach(file => { maxPage = parseInt(file.page) > maxPage ? parseInt(file.page) : maxPage; });
    files.find(file => parseInt(file.page) === maxPage).selected = true;
    this.newEnvelopeService.setSubjectPageSelected(maxPage.toString());

    if (this.withRubrics) {
      this.validRubricsHeight();
    }
  }

  verifyFileRubricElements() {
    return this.interactService.rubricElements.some(
      (x) => x.fileName === this.interactService.fileName
    );
  }

  verifyLockRubricElements(fileName) {
    return this.fileValidateService.fileConfig.some(
      (x) => x.fileName === fileName && x.lockRubric
    );
  }

  verifyChangeSignatories(listElements, isOrdered) {
    if (this.verifySignatoryStamps()) {
      const addSignatories = listElements.filter((x) =>
        !this.interactService.signatoryStamps.some((e) => e.signatoryId === x.id.toString())
      );
      const deleteSignatories = this.interactService.signatoryStamps.filter((e) =>
        !listElements.some((x) => x.id.toString() === e.signatoryId));

      if (R.pathOr(0, ['length'], deleteSignatories) > 0 || this.hasChangeFilesRubric) {
        this.interactService.signatoryStamps = this.interactService.signatoryStamps.filter((e) => listElements.some((x) => x.id.toString() === e.signatoryId));
        return true;
      } else if (R.pathOr(0, ['length'], addSignatories) > 0 || this.hasChangeFilesRubric) {
        return true;
      } else if (isOrdered !== this.interactService.isOrdered || this.hasChangeFilesRubric) {
        return true;
      }
    }
    return false;
  }

  clearSignatureConfig() {
    this.newEnvelopeService.includeSignature = false;
    this.newEnvelopeService.excludeAllSignature();
  }

  clearIncludeRubricsFileConfig() {
    this.newEnvelopeService.setSubjectIncludeRubrics(false);
    this.newEnvelopeService.includeRubrics = false;
    this.newEnvelopeService.excludeAllRubric();
  }

  clearCustomFieldsConfig() {
    this.newEnvelopeService.excludeAllCustomFields();
  }

  includeRubricsFileConfig(value) {
    this.newEnvelopeService.setSubjectIncludeRubrics(value);
    this.interactService.withRubrics = value;
    this.fileValidateService.fileConfig
      .filter((x) => {
        x.includeRubric = value;
      });
  }

  verifySignatoryStamps() {
    return R.pathOr(0, ['length'], this.interactService.signatoryStamps) > 0;
  }

  verifySignatoryRubricStamps() {
    return R.pathOr(0, ['length'], this.interactService.rubricStamps) > 0;
  }

  onPagesLoaded(event) {
    this.interactService.stopInteract('signature');
    this.interactService.stopInteract('rubric');
    this.interactService.stopInteract(CustomFieldTypeEnum.TextField);
    this.interactService.stopInteract(CustomFieldTypeEnum.CheckboxField);

    setTimeout(() => {
      this.setSignaturesPosition();
      this.hasChangeRubricsPosition();
      this.setRubricsPosition();
      this.setCustomFieldsPosition();
      this.canActivateEditMode();
      this.setDropzone();

      this.layoutService.toggleLoading(false);
      event.source.renderingQueue.pdfViewer.container.scrollTop = event.source.viewer.scrollHeight;

    }, 1000);
  }

  setDropzone() {
    const pages = document.getElementsByClassName('page');
    for (let index = 0; index < pages.length; index++) {
      const element = pages[index] as HTMLElement;
      element.classList.add('dropzone');
    }
  }

  canActivateEditMode() {
    const editModeElementStyle = getComputedStyle(document.querySelector('.edit-mode'));
    if (editModeElementStyle.display === 'none') {
      return;
    }
    this.newEnvelopeService.activateEditMode();
  }

  setSignaturesPosition() {
    let envelopeFileSelected = this.newEnvelopeService.envelopeFiles.find(x => x.checked === true);
    let signatures = this.interactService.signatoryStamps;
    let signatorys = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)["elements"] as Array<Signatory>;
    if (signatures) {
      signatures.filter(x => x.fileName === FileUtil.removeExt(envelopeFileSelected.name)).forEach((signatoryStamp: SignatoryStamp) => {
        let signatory = signatorys.find(x => x.id.toString() === signatoryStamp.signatoryId);
        this.componentDragDropService.createElementSignature(
          signatoryStamp,
          signatory,
          signatoryStamp.default
        );
      })
    }
  }

  setRubricsPosition() {
    if (!this.withRubrics) {
      this.interactService.emptySignatureAndRubricElements();
    }
    let envelopeFileSelected = this.newEnvelopeService.envelopeFiles.find(x => x.checked === true);
    let rubrics = this.interactService.rubricStamps;
    let signatorys = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)["elements"] as Array<Signatory>;
    if (rubrics) {
      rubrics.filter(x => x.fileName === FileUtil.removeExt(envelopeFileSelected.name)).forEach((rubricStamp: RubricStamp) => {
        let signatory = signatorys.find(x => x.id.toString() === rubricStamp.signatoryId);
        this.componentDragDropService.createElementRubric(
          rubricStamp,
          signatory,
          rubricStamp.default
        );
      })
    }
  }

  setCustomFieldsPosition() {
    const envelopeFileSelected = this.newEnvelopeService.envelopeFiles.find(x => x.checked === true);
    if (!envelopeFileSelected) {
      return;
    }

    const customFields = this.interactService.customFields;
    const responsibles = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)["envelopeResponsible"] ?? [];
    if (customFields) {
      customFields
        .filter(x => x.fileName === FileUtil.removeExt(envelopeFileSelected.name))
        .forEach((customField: FormCustomField) => {
          const responsible = responsibles.find(x => x.id.toString() === customField.signatoryId);
          if (!responsible) {
            return;
          }

          this.componentDragDropService.createElementCustomField(customField, responsible);
        });
    }
  }

  validRubricsHeight() {
    for (const element of this.listFiles) {
      let index = this.fileValidateService.fileConfig
        .findIndex((x) => x.fileName === FileUtil.removeExt(element.name));
      this.fileValidateService.fileConfig[index].lockRubric =
        this.getTotalHeigthSignatory(
          this.fileValidateService.fileConfig[index].height,
          this.fileValidateService.fileConfig[index].fileName);

      if (this.fileValidateService.fileConfig[index].lockRubric) {
        let file = this.fileValidateService.fileConfig[index].fileName;
        this.fileValidateService.fileConfig
          .filter((x) => {
            if (x.fileName === file) {
              x.includeRubric = false;
            }
          });
      }
    }
  }

  hasChangeRubricsPosition() {
    const index = this.rubricPosition
      .indexOf(this.rubricPosition
        .find((x) => x.fileName === this.interactService.fileName));
    if (index === -1) {
      const rubricPosition = new RubricPosition();
      rubricPosition.fileName = this.interactService.fileName;
      this.rubricPosition.push(rubricPosition);
    }

    if (this.rubricPosition.length === this.listFiles.length) {
      this.hasChangeFilesRubric = false;
      this.hasChangeElementsRubric = false;
    }
  }

  getTotalHeigthSignatory(clientHeight, fileName) {
    const rodapeViewer = 25;
    if ((this.signatories.length * (this.signatureCanvasUtils.canvasSizeRubric.height + rodapeViewer)) > clientHeight) {
      if (this.interactService.fileName === fileName) {
        this.interactService.lockRubric === true;
      };
      return true;
    } else {

      if (this.interactService.fileName == fileName) {
        this.interactService.lockRubric == true;
      };
      return false;
    }
  }

  getSubscriberBySubscriberType(value) {
    switch (value) {
      case SubscriberTypeEnum.witness:
        return 'inbox.list.card.witness';
      case SubscriberTypeEnum.signatory:
        return 'inbox.list.card.signatory';
      default:
        return '';
    }
  }

  markAsViewed(feature: FeatureEnum) {
    this.showOnboardingRememberLater = false;
    if (feature == FeatureEnum.positionSignature) {
      this.showOnboarding = false;
      this.onboardingService.openOnboarding(false, 'signature');
    }
    if (feature == FeatureEnum.newWorking) {
      this.showOnboardingNewWorking = false;
      this.onboardingService.openOnboarding(false, 'newWorking');
    }
    this.layoutService.toggleLoading(true);

    this.envelopeOnBoardingService.maskAsViewed(feature).subscribe(
      (x) => {
        this.layoutService.toggleLoading(false);
      },
      (error: any) => {
        this.layoutService.toggleLoading(false);
      }
    );
  }

  createdPositionOriginal(coordenates: CoordenatesPage, filename: string, signatoryId: string) {
    const initiStamp = new SignatoryStamp();
    const x = Math.round((coordenates.x + Number.EPSILON) * 100) / 100;
    const y = Math.round((coordenates.y + Number.EPSILON) * 100) / 100;
    initiStamp.fileName = filename;
    initiStamp.signatoryId = signatoryId;
    initiStamp.signaturePositionPixelX = coordenates.x;
    initiStamp.signaturePositionPixelY = coordenates.y;
    initiStamp.signaturePositionX = x;
    initiStamp.signaturePositionY = y;
    initiStamp.signaturePositionPage = coordenates.page;
    initiStamp.invalid = false;
    this.interactService.initStampParams(initiStamp);
  }

  createdRubricPositionOriginal(currentDimesions: FileConfig, rubricElement: HTMLElement) {
    if (currentDimesions.last === true && currentDimesions.page === '1') {
      return;
    }
    const widthToSetSignatures = currentDimesions.width;
    const heightToSetSignatures = currentDimesions.height;

    for (let index = 0; index < rubricElement.children[0].children.length; index++) {
      const element = rubricElement.children[0].children[index];

      const coordenates = PageUtil.calculateCoordenatesRubricOnPage(widthToSetSignatures, heightToSetSignatures, index);

      const x = Math.round((coordenates.x + Number.EPSILON) * 100) / 100;
      const y = Math.round((coordenates.y + Number.EPSILON) * 100) / 100;

      const initiRubricStamp = new RubricStamp();
      initiRubricStamp.fileName = rubricElement.id;
      initiRubricStamp.signatoryId = element.getAttribute('data-id');
      initiRubricStamp.page = element.id.toString();
      initiRubricStamp.positionX = x;
      initiRubricStamp.positionY = y;
      initiRubricStamp.invalid = false;
      initiRubricStamp.gId = element.getAttribute('gId');
      this.interactService.initRubricParams(initiRubricStamp);
    }
  }

  filterPages(value: any) {
    if (this.interactService.listRubrics.length > 0) {
      const rubric = this.interactService.listRubrics
        .filter((x) => x.page === value.page && x.fileName === value.fileName);
      return rubric;
    }
  }

  selectedPage() {
    let maxPage = 0;
    const files = this.fileValidateService.fileConfig.filter((x) => x.fileName === this.interactService.fileName);
    files.forEach((file) => { maxPage = parseInt(file.page, 10) > maxPage ? parseInt(file.page, 10) : maxPage; });

    const selectedPage = files.find((file) => parseInt(file.page, 10) === maxPage);
    if (!selectedPage) {
      return;
    }

    selectedPage.selected = true;
    this.newEnvelopeService.setSubjectPageSelected(selectedPage.page);
  }

  verifyChangeFile() {
    if (this.verifySignatoryStamps()) {
      const addFiles = this.files.filter((x) =>
        !this.interactService.signatoryStamps.some((e) => e.fileName === this.removeExt(x.name))
      );
      const deleteFiles = this.interactService.signatoryStamps.filter((e) =>
        !this.files.some((x) => this.removeExt(x.name) === e.fileName)
      );

      if (R.pathOr(0, ['length'], deleteFiles) > 0 || R.pathOr(0, ['length'], addFiles) > 0) {
        this.interactService.emptySignatureAndRubricElements();
        return true;
      }
      return false;
    }
  }

  handleClosePositionTour() {
    this.showOnBoardingPosition = false;

    if (this.onBoardingIsIsolatedFormTour) {
      this.markAsViewed(FeatureEnum.positionForm);
    } else {
      this.markAsViewed(FeatureEnum.positionSignature);
      if (this.newEnvelopeService.includeComponent) {
        this.markAsViewed(FeatureEnum.positionForm);
      }
    }
  }
}
